//Maincategory
export const CREATE_MAINCATEGORY = "CREATE_MAINCATEGORY"
export const CREATE_MAINCATEGORY_RED = "CREATE_MAINCATEGORY_RED"
export const GET_MAINCATEGORY = "GET_MAINCATEGORY"
export const GET_MAINCATEGORY_RED = "GET_MAINCATEGORY_RED"
export const UPDATE_MAINCATEGORY = "UPDATE_MAINCATEGORY"
export const UPDATE_MAINCATEGORY_RED = "UPDATE_MAINCATEGORY_RED"
export const DELETE_MAINCATEGORY = "DELETE_MAINCATEGORY"
export const DELETE_MAINCATEGORY_RED = "DELETE_MAINCATEGORY_RED"


//Subcategory
export const CREATE_SUBCATEGORY = "CREATE_SUBCATEGORY"
export const CREATE_SUBCATEGORY_RED = "CREATE_SUBCATEGORY_RED"
export const GET_SUBCATEGORY = "GET_SUBCATEGORY"
export const GET_SUBCATEGORY_RED = "GET_SUBCATEGORY_RED"
export const UPDATE_SUBCATEGORY = "UPDATE_SUBCATEGORY"
export const UPDATE_SUBCATEGORY_RED = "UPDATE_SUBCATEGORY_RED"
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY"
export const DELETE_SUBCATEGORY_RED = "DELETE_SUBCATEGORY_RED"


//Brand
export const CREATE_BRAND = "CREATE_BRAND"
export const CREATE_BRAND_RED = "CREATE_BRAND_RED"
export const GET_BRAND = "GET_BRAND"
export const GET_BRAND_RED = "GET_BRAND_RED"
export const UPDATE_BRAND = "UPDATE_BRAND"
export const UPDATE_BRAND_RED = "UPDATE_BRAND_RED"
export const DELETE_BRAND = "DELETE_BRAND"
export const DELETE_BRAND_RED = "DELETE_BRAND_RED"


//Testimonial
export const CREATE_TESTIMONIAL = "CREATE_TESTIMONIAL"
export const CREATE_TESTIMONIAL_RED = "CREATE_TESTIMONIAL_RED"
export const GET_TESTIMONIAL = "GET_TESTIMONIAL"
export const GET_TESTIMONIAL_RED = "GET_TESTIMONIAL_RED"
export const UPDATE_TESTIMONIAL = "UPDATE_TESTIMONIAL"
export const UPDATE_TESTIMONIAL_RED = "UPDATE_TESTIMONIAL_RED"
export const DELETE_TESTIMONIAL = "DELETE_TESTIMONIAL"
export const DELETE_TESTIMONIAL_RED = "DELETE_TESTIMONIAL_RED"


//Product
export const CREATE_PRODUCT = "CREATE_PRODUCT"
export const CREATE_PRODUCT_RED = "CREATE_PRODUCT_RED"
export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_RED = "GET_PRODUCT_RED"
export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_RED = "UPDATE_PRODUCT_RED"
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_RED = "DELETE_PRODUCT_RED"

//Cart
export const CREATE_CART = "CREATE_CART"
export const CREATE_CART_RED = "CREATE_CART_RED"
export const GET_CART = "GET_CART"
export const GET_CART_RED = "GET_CART_RED"
export const UPDATE_CART = "UPDATE_CART"
export const UPDATE_CART_RED = "UPDATE_CART_RED"
export const DELETE_CART = "DELETE_CART"
export const DELETE_CART_RED = "DELETE_CART_RED"

//Wishlist
export const CREATE_WISHLIST = "CREATE_WISHLIST"
export const CREATE_WISHLIST_RED = "CREATE_WISHLIST_RED"
export const GET_WISHLIST = "GET_WISHLIST"
export const GET_WISHLIST_RED = "GET_WISHLIST_RED"
export const UPDATE_WISHLIST = "UPDATE_WISHLIST"
export const UPDATE_WISHLIST_RED = "UPDATE_WISHLIST_RED"
export const DELETE_WISHLIST = "DELETE_WISHLIST"
export const DELETE_WISHLIST_RED = "DELETE_WISHLIST_RED"

//Checkout
export const CREATE_CHECKOUT = "CREATE_CHECKOUT"
export const CREATE_CHECKOUT_RED = "CREATE_CHECKOUT_RED"
export const GET_CHECKOUT = "GET_CHECKOUT"
export const GET_CHECKOUT_RED = "GET_CHECKOUT_RED"
export const UPDATE_CHECKOUT = "UPDATE_CHECKOUT"
export const UPDATE_CHECKOUT_RED = "UPDATE_CHECKOUT_RED"
export const DELETE_CHECKOUT = "DELETE_CHECKOUT"
export const DELETE_CHECKOUT_RED = "DELETE_CHECKOUT_RED"

//Newsletter
export const CREATE_NEWSLETTER = "CREATE_NEWSLETTER"
export const CREATE_NEWSLETTER_RED = "CREATE_NEWSLETTER_RED"
export const GET_NEWSLETTER = "GET_NEWSLETTER"
export const GET_NEWSLETTER_RED = "GET_NEWSLETTER_RED"
export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER"
export const UPDATE_NEWSLETTER_RED = "UPDATE_NEWSLETTER_RED"
export const DELETE_NEWSLETTER = "DELETE_NEWSLETTER"
export const DELETE_NEWSLETTER_RED = "DELETE_NEWSLETTER_RED"

//Contact Us
export const CREATE_CONTACT_US = "CREATE_CONTACT_US"
export const CREATE_CONTACT_US_RED = "CREATE_CONTACT_US_RED"
export const GET_CONTACT_US = "GET_CONTACT_US"
export const GET_CONTACT_US_RED = "GET_CONTACT_US_RED"
export const UPDATE_CONTACT_US = "UPDATE_CONTACT_US"
export const UPDATE_CONTACT_US_RED = "UPDATE_CONTACT_US_RED"
export const DELETE_CONTACT_US = "DELETE_CONTACT_US"
export const DELETE_CONTACT_US_RED = "DELETE_CONTACT_US_RED"

export const CREATE_BANNER = "CREATE_BANNER"
export const CREATE_BANNER_RED = "CREATE_BANNER_RED"
export const GET_BANNER = "GET_BANNER"
export const GET_BANNER_RED = "GET_BANNER_RED"
export const UPDATE_BANNER = "UPDATE_BANNER"
export const UPDATE_BANNER_RED = "UPDATE_BANNER_RED"
export const DELETE_BANNER = "DELETE_BANNER"
export const DELETE_BANNER_RED = "DELETE_BANNER_RED"

export const CREATE_SHOP = "CREATE_SHOP"
export const CREATE_SHOP_RED = "CREATE_SHOP_RED"
export const GET_SHOP = "GET_SHOP"
export const GET_SHOP_RED = "GET_SHOP_RED"
export const UPDATE_SHOP = "UPDATE_SHOP"
export const UPDATE_SHOP_RED = "UPDATE_SHOP_RED"
export const DELETE_SHOP = "DELETE_Shop"
export const DELETE_SHOP_RED = "DELETE_SHOP_RED"
